export default __webpack_public_path__ + "static/media/photo7.781e3806.jpg";